/**
 * This file is part of ONP.
 *
 * Copyright (c) 2014 Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Kosova <ivetta.kosova@opensoftdev.ru>
 */

define(['jquery', 'assets/js/modules/designFacePreview/guideLines/view/abstractView'], function($, AbstractView) {
    return AbstractView.extend({
        renderBleedZone: function(options) {
            options = options || {};
            var crossX = Math.round(this.width / 2);
            var crossY = Math.round(this.height * 0.75);

            var arcSize = Math.round(this.width / 29);
            var arcGap = Math.round(arcSize / 2);

            this.context.strokeStyle = this.bleedZoneColor;

            if (options.background) {
                this.context.fillStyle = options.background;
                this.context.fillRect(0, 0, this.width, this.height);
                if (this.foldingType) {
                    this.textBackground = options.background;
                }
            }
            this.context.strokeRect(0, 0, this.width, this.height);

            this.context.fillStyle = this.bleedZoneColor;
            this.context.beginPath();
            this.context.moveTo(crossX - arcGap - arcSize, this.height);
            this.context.arcTo(crossX - arcGap, this.height, crossX - arcGap, this.height - arcSize, arcSize);
            this.context.lineTo(crossX, crossY);
            this.context.lineTo(crossX + arcGap, this.height - arcSize);
            this.context.arcTo(crossX + arcGap, this.height, crossX + arcGap + arcSize, this.height, arcSize);
            this.context.closePath();
            this.context.fill();

            if (options.legend && options.legend.text) {
                var height = this.model.get('isVertical') ? this.width : this.height;
                this._addLegend(options.legend, 0, Math.round(height / 2));
            }
        },

        renderTrimZone: function(options) {
            options = options || {};

            var widthOffset = Math.ceil(this.getDeltaWidth(this.zones.trimWidth) / 4);
            var heightOffset = Math.round(this.getDeltaHeight(this.zones.trimHeight) / 4);

            this.context.strokeStyle = this.trimZoneColor;

            this._renderOffsetZone(widthOffset, heightOffset, options);

            if (options.legend && options.legend.text) {
                var height = this.model.get('isVertical') ? this.width : this.height;
                this._addLegend(options.legend, widthOffset, Math.round(height / 2) - 15);
            }
        },

        renderSafeZone: function(options) {
            options = options || {};

            var widthOffset = Math.ceil(this.getDeltaWidth(this.zones.safeWidth) / 4);
            var heightOffset = Math.round(this.getDeltaHeight(this.zones.safeHeight) / 4);

            this.context.strokeStyle = this.safeZoneColor;

            this._renderOffsetZone(widthOffset, heightOffset, options);

            if (options.legend && options.legend.text) {
                var height = this.model.get('isVertical') ? this.width : this.height;
                this._addLegend(options.legend, widthOffset, Math.round(height / 2) - 35);
            }
        },

        renderFolding: function() {
            var crossX = Math.round(this.width / 2);
            var crossY = Math.round(this.height * 0.75);

            this.context.save();
            this.context.strokeStyle = this.foldColor;
            this.context.beginPath();
            if (this.context.setLineDash) {
                this.context.setLineDash([5]);
            }
            this.context.moveTo(crossX, 0);
            this.context.lineTo(crossX, crossY);
            this.context.moveTo(0, crossY);
            this.context.lineTo(this.width, crossY);
            this.context.stroke();
            this.context.restore();
        },

        _renderOffsetZone: function(widthOffset, heightOffset, options) {
            var crossX = Math.round(this.width / 2);
            var crossY = Math.round(this.height * 0.75);

            if (!widthOffset) {
                widthOffset = 1;
            }
            if (!heightOffset) {
                heightOffset = 1;
            }

            var arcSize = Math.ceil(this.width / 29 - widthOffset);
            var arcGap = Math.round(arcSize / 2);

            this.context.beginPath();
            this.context.moveTo(widthOffset, heightOffset);
            this.context.lineTo(this.width - widthOffset, heightOffset);
            this.context.lineTo(this.width - widthOffset, this.height - heightOffset);
            this.context.lineTo(crossX + arcGap + arcSize + widthOffset, this.height - heightOffset);
            this.context.arcTo(
                crossX + arcGap + widthOffset,
                this.height - heightOffset,
                crossX + arcGap + widthOffset,
                this.height - heightOffset - arcSize,
                arcSize
            );
            this.context.lineTo(crossX + widthOffset, crossY - heightOffset);
            this.context.lineTo(crossX - widthOffset, crossY - heightOffset);
            this.context.lineTo(crossX - arcGap - widthOffset, this.height - arcSize - heightOffset);
            this.context.arcTo(
                crossX - arcGap - widthOffset,
                this.height - heightOffset,
                crossX - arcSize - arcGap - widthOffset,
                this.height - heightOffset,
                arcSize
            );
            this.context.lineTo(widthOffset, this.height - heightOffset);
            this.context.closePath();
            if (options.background) {
                this.context.fillStyle = options.background;
                this.context.fill();
                if (this.foldingType) {
                    this.textBackground = options.background;
                }
            }
            this.context.stroke();
        }
    });
});
